<template>
  <div id="Song" class="song" :class="{'full-height': !isKaraokeSite()}">
    <div v-if="isKaraokeSite()" class="karaoke-song-wrapper" :style="{ backgroundColor: bgColor, color: textColor }">
      <div class="song-details">
        <img ref="image" :key="song._id" @load="getAverageColor" :src="'/api/stream/' + song.image" />
        <div class="song-info">
          <p>{{ song.artist }}</p>
          <h5>{{ song.songName }}</h5>
        </div>
      </div>
      <div class="song-text">
        <pre class="text-center">{{ song.textContent }}</pre>
      </div>
    </div>
    <div v-else ref="container" class="matrice-song-wrapper" :class="{'more-songs': songs.length > 0}" :style="{ backgroundColor: bgColor, color: textColor }">
      <div class="matrice-song">
        <div class="matrice-song--inner">
          <img ref="image" :key="song._id" @load="getAverageColor" :src="'/api/stream/' + song.image" />
          <div class="song-info">
            <h3>{{ song.artist }}</h3>
            <h1>{{ song.songName }}</h1>
          </div>
          <div class="download-options">
            <button
                type="button"
                class="download"
                :style="{ backgroundColor: textColor, color: bgColor }"
                @click="tryDownload(song._id)"
                :title="$t('download')"
            >
              <span>{{ $t('download') }}</span>
              <download-icon />
            </button>
            <button
                type="button"
                class="download-text"
                :style="{ backgroundColor: textColor, color: bgColor }"
                :title="$t('download_text')"
                @click="downloadLyrics(song)"
            >
              <text-icon class="text-icon" />
              <download-icon class="download-icon" />
            </button>
          </div>
        </div>
      </div>
      <div v-if="songs.length > 0" class="other-songs">
        <div
          v-for="song in songs"
          :key="song._id"
          class="song"
          @click="selectSong(song)"
        >
          <div class="song-info">
            <img ref="image" @load="getAverageColor" :src="'/api/stream/' + song.image" />
            <div class="song-info--text">
              <p>{{ song.artist }}</p>
              <h5>{{ song.songName }}</h5>
            </div>
          </div>
          <button
              type="button"
              class="download"
              :style="{ backgroundColor: bgColor, color: textColor }"
              :title="$t('download')"
              @click.stop.prevent="tryDownload(song._id)"
          >
            <download-icon />
          </button>
        </div>
      </div>
    </div>
    <div class="download-modal" :class="showModal ? 'show' : ''">
      <div class="download-modal__overlay" @click="showModal = false" />
      <div class="download-modal__content">
        <div class="download-modal__body">
          <p>Dcoin: 0</p>
          <button class="buy-dcoin" @click="createStripeDcoinSession">
            <span>{{ $t("buy_dcoin") }}</span>
            <img src="./../assets/dcoin.jpg" alt="" />
          </button>
        </div>
        <div class="download-modal__close">
          <button
              type="button"
              class="button button-danger"
              @click="showModal = false"
          >
            {{ $t("close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSong, getSongUrl } from "@/services/songs";
import { isKaraokeSite } from "@/services/utils";
import { FastAverageColor } from 'fast-average-color';
import DownloadIcon from "./svg/DownloadIcon.vue";
import {getArtistSongs, purchaseSong} from "@/services/songs";
import {getUser} from "@/services/users";
import TextIcon from "./svg/TextIcon.vue";
import { createStripeDcoinCheckoutSession } from "@/services/subscriptions";

export default {
  name: "song",
  components: {TextIcon, DownloadIcon},
  metaInfo() {
    if (!this.song) return {};

    const origin = typeof window !== 'undefined' ? window.location.origin : '';

    const artist = this.song.artist.replace(/\s/g, '-');
    const songName = this.song.songName.replace(/\s/g, '-');
    const isKaraoke = this.isKaraokeSite();

    const fullTitle = `${isKaraoke ? 'Karaoke' : 'Matrice'} Studio D - ${this.song.artist} - ${this.song.songName}`;

    return {
      title: fullTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: "✔ Slusaj ✔ Pevaj ✔ Pretplati se, Preko 10000 matrica na jednom mestu, samo 9.99€ mesečno!",
        },
        {
          hid: "twitter:card",
          name: "twitter:card",
          content: `${this.song.artist} - ${this.song.songName}`,
        },
        {
          hid: "twitter:site",
          name: "twitter:site",
          content: "@matricestudiod",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: fullTitle,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: "✔ Slusaj ✔ Pevaj ✔ Pretplati se, Preko 10000 matrica na jednom mestu, samo 9.99€ mesečno!",
        },
        {
          hid: "twitter:creator",
          name: "twitter:creator",
          content: "@matricestudiod",
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: `${origin}/api/stream/${this.song.image}`,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: fullTitle,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: this.socialUrl,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: `${origin}/api/stream/${this.song.image}`,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "✔ Slusaj ✔ Pevaj ✔ Pretplati se, Preko 10000 matrica na jednom mestu, samo 9.99€ mesečno",
        },
        {
          hid: "og:site_name",
          property: "og:site_name",
          content: fullTitle,
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "website",
        },
        {
          hid: "robots",
          name: "robots",
          content: "index,follow",
        },
      ],
    };
  },
  props: {
    name: String,
    songName: String,
    id: String,
  },
  data() {
    return {
      song: {},
      songs: [],
      socialUrl: window.location.origin + encodeURI(this.$route.path),
      socialTags: "",
      socialTitle: "",
      socialDescription: "",
      shareActive: false,
      bgColor: null,
      textColor: null,
      showModal: false,
    };
  },
  watch: {
    $route(to, from) {
      this.loadSong();
    },
    song(newVal) {
      if (newVal && newVal.artist) {
        this.getAllSongs(newVal.artist.replace(/-/g, " "))
      }
    },
  },
  computed: {
    loggedUser() {
      return this.$store.state.user;
    },
    isLogged() {
      return this.$store.state.isLogged;
    },
    matriceTokens() {
      return this.$store.getters.matriceTokens;
    },
  },
  methods: {
    isKaraokeSite,
    toggleCopy: function () {
      let textToCopy = this.$refs.copyUrl.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
    },
    loadSong: function () {
      let self = this;
      getSong(this.id, function (data) {
        if (data.error) {
          self.$emit("show-snackbar", data.payload.data.status, "error");
          self.$router.push("/");
        } else {
          self.song = data.payload;
          self.socialTitle = self.song.artist + "-" + self.song.songName;
          self.socialDescription = self.song.textContent;
          self.socialTags = self.song.tags.replace(/ /g, ",").replace(/#/g, "");
          getSongUrl(self.song._id, function (data) {
            if (data.error) {
              self.$emit("show-snackbar", data.payload.data.status, "error");
              self.$router.push("/");
            } else {
              self.$emit("song-selected", {
                songUrl: data.payload.url,
                song: self.song,
                limit: data.payload.limit,
                playlistId: null,
              });
            }
          });
        }
      });
    },
    getAverageColor() {
      const fac = new FastAverageColor();
      fac.getColorAsync(this.$refs.image)
        .then(color => {
          this.bgColor = color.rgb;
          this.textColor = color.isDark ? 'white' : 'black';
        })
    },
    downloadSong(songUrl) {
      const pathname = new URL(songUrl).pathname;
      const filename = pathname.substring(pathname.lastIndexOf("/") + 1);

      setTimeout(() => {
        const link = document.createElement("a");
        link.href = songUrl;
        link.download = filename;
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, 0);
    },
    async tryDownload(id) {
      const self = this;
      if (self.isLogged) {
        if (self.matriceTokens > 0) {
          purchaseSong(id, 0, function (data) {
            if (data.error) {
              self.showSnackbar(data.payload.data.status, "error");
            } else {
              self.downloadSong(data.payload.songUrl);
              getUser(function (data) {
                self.$store.state.user = data.payload;
              });
            }
          });
        } else {
          self.showModal = true;
        }
      } else {
        self.$emit("show-login-modal");
      }
    },
    getAllSongs(artist) {
      const self = this;
      getArtistSongs(artist, function (data) {
        if (data.error) {
          self.$emit("show-snackbar", data.payload.data.status, "error");
          self.$router.push("/artists");
        } else {
          self.songs = data.payload;
          const idToRemove = self.song._id
          const index = self.songs.findIndex(song => song._id === idToRemove);
          if (index !== -1) {
            self.songs.splice(index, 1);
          }
        }
      });
    },
    selectSong: function (song) {
      this.$router.push(
          "/artist/" +
          song.artist.replace(/\s/g, "-") +
          "/" +
          song.songName.replace(/\s/g, "-") +
          "/" +
          song._id
      );
    },
    downloadLyrics(song) {
      const lyrics = song.textContent || 'No lyrics available.';
      const fileName = `${song.artist}-${song.songName}.txt`;

      const blob = new Blob([lyrics], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    createStripeDcoinSession() {
      createStripeDcoinCheckoutSession(function (data) {
        if (data.error) {
          self.$emit("show-snackbar", data.payload.data.status, "error");
          self.$router.push("/");
        } else {
          window.location.assign(data.payload.sessionUrl);
        }
      });
    },
  },
  beforeMount() {
    this.loadSong();
  },
};
</script>
<style lang="scss" scoped>
pre {
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  font-family: Roboto, sans-serif;
  pointer-events: auto;
  box-sizing: inherit;
  background-repeat: no-repeat;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  width: 100%;
  color: rgba(0, 0, 0, 0.8);
  padding: 0 24px 20px;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}

.download-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  display: none;
  padding: 20px;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  &.show {
    display: flex;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100dvh;
    z-index: 2;
    background-color: rgba(#000, 0.3);
  }

  &__content {
    position: relative;
    z-index: 4;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    gap: 20px;
    background-color: var(--body-background-invert);
    border-radius: 12px;
    border: 1px solid var(--border-color);
    box-shadow: 0 0 10px 0 rgba(var(--box-shadow), 0.2);
    width: 100%;
    max-width: 450px;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 16px;

    p {
      font-size: 22px;
      font-weight: 500;
      text-align: center;
      color: #c41e3a;
    }

    .buy-dcoin {
      height: 60px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border-radius: 100px;
      padding: 0 5px 0 16px;
      background-color: var(--body-background);
      color: var(--text) !important;
      border: 1px solid var(--body-background);
      transition: 0.15s;

      span {
        font-weight: 500;
        font-size: 18px;
        color: var(--brand-color);
      }

      img {
        height: 50px;
        width: 50px;
        border-radius: 100%;
      }

      &:hover {
        gap: 16px;

        span {
          color: var(--brand-color) !important;
        }
      }
    }
  }

  &__close {
    padding: 8px;
    border-top: 1px solid var(--border-color);

    button {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      border-radius: 12px;
      transition: 0.15s;
    }
  }
}
</style>
